// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__K1vfu","item":"style_item__z_mST","left":"style_left__Vi25V","date":"style_date__IfDa6"};